import { styled } from 'styled-components';
import { verticalFadeIn, verticalFadeOut } from '../../../../../theme/animations.js';
import { Media } from '../../../../../theme/Media.js';
import { ANIMATION_DURATION_MS } from './constants.js';
export const Wrapper = styled.div `
  ${({ theme }) => theme.shadows.large};
  list-style: none;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey00_6};
  width: ${({ width }) => width}px;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  animation: ${({ $visible, $isTop }) => ($visible ? verticalFadeIn($isTop) : verticalFadeOut($isTop))} ${ANIMATION_DURATION_MS}ms ease
    forwards;
`;
export const Button = styled.button `
  height: 36px;
  max-width: 300px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  gap: 8px;
  background: ${({ theme }) => theme.colors.grey00_7};
  border: 1px solid ${({ theme }) => theme.colors.grey30_1};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.grey100_1};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.grey70_1};
    cursor: pointer;
  }

  &:focus,
  &:focus-visible {
    outline: 0;
    border: 1px solid ${({ theme }) => theme.colors.main};
    ${({ theme }) => theme.shadows.focus}
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.grey05_4};
    border: 1px solid ${({ theme }) => theme.colors.grey10_2};
    color: ${({ theme }) => theme.colors.grey100_2};
    cursor: not-allowed;
  }

  @media ${Media.xsMax} {
    max-width: unset;
    width: 100%;
  }
`;
export const ButtonWrapper = styled.div `
  display: inline-flex;
`;
export const CaretWrapper = styled.span `
  display: flex;
  flex: 0 0 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
`;
